import React, { useRef } from "react"
import SectionArticle from "../../components/organisms/section-article/section-article"
import Layout from "../../shared/components/organisms/layout/layout"
import SEO from "../../shared/components/seo"
import OthersEvents from "../../shared/components/molecules/others-events/others-events"
import useBrowserMode from "../../shared/hooks/useBrowserMode"
import useMobileMode from "../../shared/hooks/useMobileMode"
import WebinarService from "../../shared/services/webinar"
import { siteUrl } from "../../shared/state/utils/site-url"
import "../../shared/_shared/Index.scss"

const ArticleTemplate = props => {
  const { isBrowser } = useBrowserMode()
  const { isMobile, currentPage } = useMobileMode()

  let _parentNode = isBrowser ? document.querySelector("body") : null
  const parentNode = _parentNode
  const articleRef = useRef()
  const articleData = props.pageContext.article

  React.useEffect(() => {
    if (parentNode.scrollTop > 0) {
      parentNode.scroll({
        top: 0,
        behavior: "smooth",
      })
    }
  })

  React.useEffect(() => {
    let payload = {
      cmsId: articleData.contentful_id,
      typeContent: "ARTICULO",
    }

    WebinarService.postView(payload)
      .then(res => {
        if (res.status !== 200) {
          console.log("Error registro vista", error)
        }
      })
      .catch(error => {
        console.log("Error registro vista", error)
      })
  }, [])

  let seoImg =
    articleData.imagenArticuloCompleta &&
    articleData.imagenArticuloCompleta[0].file.url

  const DefaultArticleSchema = {
    "@context": "https://schema.org/",
    "@type": "Article",
    author: {
      "@type": "Organization",
      name: "TENA",
    },
    headline: articleData.title,
    image: articleData.imagenArticuloPrevisualizacion[0].fluid.src,
    datePublished: articleData.createdAt,
    publisher: {
      "@type": "Organization",
      name: "TENA",
      logo: {
        "@type": "ImageObject",
        url: "https://www.tena.com.co/logo.png",
      },
    },
    keywords: articleData.keywords || "",
    dateModified: articleData.createdAt,
    mainEntityOfPage: `${siteUrl}/academia-tena/${articleData.slug}`,
    description: articleData.metaDescripcion.metaDescripcion,
  }

  return (
    <Layout title={articleData.metaTitulo} isMobile={isMobile} currentPage={currentPage}>
      <SEO
        title={articleData.metaTitulo}
        description={articleData.metaDescripcion?.metaDescripcion}
        slug={"/academia-tena/" + articleData.slug}
        lang={props.pageContext.language}
        image={seoImg}
        alternatesInvalidCountries={articleData.paisesDeRestriccionDelArticulo}
        script={
          articleData.schema?.schema
            ? JSON.parse(articleData.schema.schema)
            : DefaultArticleSchema
        }
      />
      <article ref={articleRef}>
        <SectionArticle
          ismobile={isMobile}
          article={articleData}
          products={
            <OthersEvents othersEvents={articleData.tePuedenInteresar} />
          }
        />
      </article>
    </Layout>
  )
}

export default ArticleTemplate
